@if (spec) {
<div
  class="app-chart-host"
  [style.height.px]="spec.height"
  [style.max-width.px]="spec.width"
>
  <canvas
    baseChart
    [type]="spec.type"
    [data]="spec.data"
    [options]="spec.options"
    [plugins]="spec.plugins"
  >
  </canvas>
</div>
}
